// extracted by mini-css-extract-plugin
export default {"likeButton":"DU-z","unLikedButton":"EU-z","likedButton":"FU-z"};